import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "container mt-4 animated fadeIn" }
const _hoisted_2 = { class: "row mb-2" }
const _hoisted_3 = { class: "font-weight-bold text-secondary text-left" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M18,11V13H10L13.5,16.5L12.08,17.92L6.16,12L12.08,6.08L13.5,7.5L10,11H18M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12Z"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" New Bank or Crypto Account ")
const _hoisted_6 = {
  key: 0,
  class: "rounded shadow p-4"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "form-group text-left" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "amount" }, " *Select Your Account Type: ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "form-check form-check-inline" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "isCrypto1"
}, "Fiat", -1)
const _hoisted_14 = { class: "form-check form-check-inline" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "isCrypto2"
}, "Crypto", -1)
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("h5", null, "Receiving Bank Information")
], -1)
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "form-group text-left" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { for: "currencyId" }, " Currency:* ", -1)
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_23 = { class: "form-group text-left" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { for: "recipientFullName" }, " Recipient Full Name:* ", -1)
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_27 = { class: "form-group text-left" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "bankName" }, " Bank Name:* ", -1)
const _hoisted_29 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_30 = { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" }
const _hoisted_31 = { class: "form-group text-left" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { for: "bankAddress" }, " Bank Address:* ", -1)
const _hoisted_33 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_34 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_35 = { class: "form-group text-left" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", { for: "bankAccountNumber" }, " Bank Account Number:* ", -1)
const _hoisted_37 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_38 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_39 = { class: "form-group text-left" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { for: "postalCode" }, " Postal Code:* ", -1)
const _hoisted_41 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_42 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_43 = { class: "form-group text-left" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", { for: "city" }, " City:* ", -1)
const _hoisted_45 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_46 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_47 = { class: "form-group text-left" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { for: "province" }, " Province:* ", -1)
const _hoisted_49 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_50 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_51 = { class: "form-group text-left" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", { for: "country" }, " Country:* ", -1)
const _hoisted_53 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_54 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_55 = { class: "form-group text-left" }
const _hoisted_56 = /*#__PURE__*/_createVNode("label", { for: "swiftOrBic" }, " SWIFT/BIC:* ", -1)
const _hoisted_57 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_58 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_59 = { class: "form-group text-left" }
const _hoisted_60 = /*#__PURE__*/_createVNode("label", { for: "transitNumber" }, " Transit Number:* ", -1)
const _hoisted_61 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_62 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_63 = { class: "form-group text-left" }
const _hoisted_64 = /*#__PURE__*/_createVNode("label", { for: "institutionNumber" }, " Institution Number:* ", -1)
const _hoisted_65 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("h5", null, "Account Holder Information")
], -1)
const _hoisted_67 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_68 = { class: "form-group text-left" }
const _hoisted_69 = /*#__PURE__*/_createVNode("label", { for: "accountName" }, " Account Name:* ", -1)
const _hoisted_70 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_71 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_72 = { class: "form-group text-left" }
const _hoisted_73 = /*#__PURE__*/_createVNode("label", { for: "phoneNumber" }, " Phone Number:* ", -1)
const _hoisted_74 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_75 = { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" }
const _hoisted_76 = { class: "form-group text-left" }
const _hoisted_77 = /*#__PURE__*/_createVNode("label", { for: "legalAddressAccountHolder" }, " Legal Address of Account Holder:* ", -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("small", null, " Full Address, City, Province, Postal Code. ", -1)
const _hoisted_79 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_80 = {
  key: 1,
  class: "row"
}
const _hoisted_81 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_82 = { class: "form-group text-left" }
const _hoisted_83 = /*#__PURE__*/_createVNode("label", { for: "currencyId" }, " Currency:* ", -1)
const _hoisted_84 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_85 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_86 = { class: "form-group text-left" }
const _hoisted_87 = /*#__PURE__*/_createVNode("label", { for: "accountName" }, " Account Name:* ", -1)
const _hoisted_88 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_89 = { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" }
const _hoisted_90 = { class: "form-group text-left" }
const _hoisted_91 = /*#__PURE__*/_createVNode("label", { for: "cryptoAddress" }, " Crypto Address:* ", -1)
const _hoisted_92 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_93 = {
  key: 2,
  class: "row"
}
const _hoisted_94 = /*#__PURE__*/_createVNode("div", { class: "col" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-exclamation-triangle" }),
    /*#__PURE__*/_createTextVNode(" Your account will be activated when we will have verified the information, please be patient. ")
  ])
], -1)
const _hoisted_95 = {
  key: 3,
  class: "row"
}
const _hoisted_96 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("a", {
          class: "pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
        }, [
          _hoisted_4
        ]),
        _hoisted_5
      ])
    ]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createVNode("div", _hoisted_12, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    disabled: _ctx.isOnlyRead,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCrypto = $event)),
                    value: false,
                    id: "isCrypto1",
                    type: "radio"
                  }, null, 8, ["disabled"]), [
                    [_vModelRadio, _ctx.isCrypto]
                  ]),
                  _hoisted_13
                ]),
                _createVNode("div", _hoisted_14, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    disabled: _ctx.isOnlyRead,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isCrypto = $event)),
                    id: "isCrypto2",
                    value: true,
                    type: "radio"
                  }, null, 8, ["disabled"]), [
                    [_vModelRadio, _ctx.isCrypto]
                  ]),
                  _hoisted_15
                ])
              ])
            ])
          ]),
          (!_ctx.isCrypto)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _hoisted_17,
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createVNode("select", {
                      id: "currencyId",
                      disabled: _ctx.isOnlyRead,
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.bankForm.props.currencyId = $event))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fiatsAssets, (c) => {
                        return (_openBlock(), _createBlock("option", {
                          key: c.id,
                          value: c.id
                        }, _toDisplayString(c.id) + " " + _toDisplayString(c.description), 9, ["value"]))
                      }), 128))
                    ], 8, ["disabled"]), [
                      [_vModelSelect, _ctx.bankForm.props.currencyId]
                    ]),
                    (_ctx.bankForm.controls.currencyId.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_21, _toDisplayString(_ctx.bankForm.controls.currencyId.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      disabled: _ctx.isOnlyRead,
                      id: "recipientFullName",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.bankForm.props.recipientFullName = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.recipientFullName]
                    ]),
                    (_ctx.bankForm.controls.recipientFullName.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_25, _toDisplayString(_ctx.bankForm.controls.recipientFullName.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      id: "bankName",
                      class: "form-control",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.bankForm.props.bankName = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.bankName]
                    ]),
                    (_ctx.bankForm.controls.bankName.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_29, _toDisplayString(_ctx.bankForm.controls.bankName.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      id: "bankAddress",
                      class: "form-control",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.bankForm.props.bankAddress = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.bankAddress]
                    ]),
                    (_ctx.bankForm.controls.bankAddress.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_33, _toDisplayString(_ctx.bankForm.controls.bankAddress.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_34, [
                  _createVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "bankAccountNumber",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.bankForm.props.bankAccountNumber = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.bankAccountNumber]
                    ]),
                    (!_ctx.isOnlyRead && _ctx.bankForm.controls.bankAccountNumber.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_37, _toDisplayString(_ctx.bankForm.controls.bankAccountNumber.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_38, [
                  _createVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "postalCode",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.bankForm.props.postalCode = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.postalCode]
                    ]),
                    (_ctx.bankForm.controls.postalCode.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_41, _toDisplayString(_ctx.bankForm.controls.postalCode.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "city",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.bankForm.props.city = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.city]
                    ]),
                    (_ctx.bankForm.controls.city.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_45, _toDisplayString(_ctx.bankForm.controls.city.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_46, [
                  _createVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "province",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.bankForm.props.province = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.province]
                    ]),
                    (_ctx.bankForm.controls.province.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_49, _toDisplayString(_ctx.bankForm.controls.province.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_50, [
                  _createVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "country",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.bankForm.props.country = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.country]
                    ]),
                    (_ctx.bankForm.controls.country.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_53, _toDisplayString(_ctx.bankForm.controls.country.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_54, [
                  _createVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "swiftOrBic",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.bankForm.props.swiftOrBic = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.swiftOrBic]
                    ]),
                    (_ctx.bankForm.controls.swiftOrBic.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_57, _toDisplayString(_ctx.bankForm.controls.swiftOrBic.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_58, [
                  _createVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "transitNumber",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.bankForm.props.transitNumber = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.transitNumber]
                    ]),
                    (_ctx.bankForm.controls.transitNumber.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_61, _toDisplayString(_ctx.bankForm.controls.transitNumber.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_62, [
                  _createVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "institutionNumber",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.bankForm.props.institutionNumber = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.institutionNumber]
                    ]),
                    (_ctx.bankForm.controls.institutionNumber.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_65, _toDisplayString(_ctx.bankForm.controls.institutionNumber.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_66,
                _createVNode("div", _hoisted_67, [
                  _createVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "accountName",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.bankForm.props.accountName = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.accountName]
                    ]),
                    (_ctx.bankForm.controls.accountName.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_70, _toDisplayString(_ctx.bankForm.controls.accountName.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_71, [
                  _createVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "phoneNumber",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.bankForm.props.phoneNumber = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.phoneNumber]
                    ]),
                    (_ctx.bankForm.controls.phoneNumber.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_74, _toDisplayString(_ctx.bankForm.controls.phoneNumber.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_75, [
                  _createVNode("div", _hoisted_76, [
                    _hoisted_77,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "legalAddressAccountHolder",
                      disabled: _ctx.isOnlyRead,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.bankForm.props.legalAddressAccountHolder = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.bankForm.props.legalAddressAccountHolder]
                    ]),
                    _hoisted_78,
                    (_ctx.bankForm.controls.legalAddressAccountHolder.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_79, _toDisplayString(_ctx.bankForm.controls.legalAddressAccountHolder.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isCrypto)
            ? (_openBlock(), _createBlock("div", _hoisted_80, [
                _createVNode("div", _hoisted_81, [
                  _createVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _withDirectives(_createVNode("select", {
                      disabled: _ctx.isOnlyRead,
                      id: "currencyId",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.cryptoForm.props.currencyId = $event))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cryptosAssets, (c) => {
                        return (_openBlock(), _createBlock("option", {
                          key: c.id,
                          value: c.id
                        }, _toDisplayString(c.id) + " " + _toDisplayString(c.description), 9, ["value"]))
                      }), 128))
                    ], 8, ["disabled"]), [
                      [_vModelSelect, _ctx.cryptoForm.props.currencyId]
                    ]),
                    (_ctx.cryptoForm.controls.currencyId.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_84, _toDisplayString(_ctx.cryptoForm.controls.currencyId.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_85, [
                  _createVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      disabled: _ctx.isOnlyRead,
                      id: "accountName",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.cryptoForm.props.accountName = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.cryptoForm.props.accountName]
                    ]),
                    (_ctx.cryptoForm.controls.accountName.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_88, _toDisplayString(_ctx.cryptoForm.controls.accountName.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_89, [
                  _createVNode("div", _hoisted_90, [
                    _hoisted_91,
                    _withDirectives(_createVNode("input", {
                      disabled: _ctx.isOnlyRead,
                      type: "text",
                      class: "form-control",
                      id: "cryptoAddress",
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.cryptoForm.props.cryptoAddress = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.cryptoForm.props.cryptoAddress]
                    ]),
                    (_ctx.cryptoForm.controls.cryptoAddress.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_92, _toDisplayString(_ctx.cryptoForm.controls.cryptoAddress.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isActive)
            ? (_openBlock(), _createBlock("div", _hoisted_93, [
                _hoisted_94
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isOnlyRead)
            ? (_openBlock(), _createBlock("div", _hoisted_95, [
                _createVNode("div", _hoisted_96, [
                  _createVNode("button", {
                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                    class: "btn btn-sat-street text-white"
                  }, " Save ")
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}